import React, { useState } from 'react';

export default function TextForm(props) {
    const [text, setText] = useState("");

    const handleOnChange = (event) => {
        setText(event.target.value);
    }

    const handleUcClick = () => {
        let newText = text.toUpperCase();
        setText(newText);
        props.showAlert("Text has been converted to UPPERCASE!", "success");
    }
    const handleLcClick = () => {
        let newText = text.toLowerCase();
        setText(newText);
        props.showAlert("Text has been converted to lowercase!", "success");
    }
    const handleSpeakClick = () => {
        let message = new SpeechSynthesisUtterance();
        message.text = text;
        window.speechSynthesis.speak(message);
        props.showAlert("Text has been spoken!", "success");
    }

    const handleCapsClick = () => {
        let capitalizeWords = text[0].toUpperCase();
        for (let i = 1; i <= text.length - 1; i++) {
            let currentCharacter, previousCharacter = text[i - 1];
            if (previousCharacter && previousCharacter === " ") {
                currentCharacter = text[i].toUpperCase();
            } else {
                currentCharacter = text[i];
            }
            capitalizeWords = capitalizeWords + currentCharacter;
        }
        setText(capitalizeWords);
        props.showAlert("Text has been Capitalized!", "success");
    }

    const handleCopy = () => {
        let text = document.getElementById("textInput");
        text.select();
        navigator.clipboard.writeText(text.value);
        document.getSelection().removeAllRanges();
        props.showAlert("Text has been copied!", "success");
    }

    const handleExtraSpaces = () => {
        let newText = text.split(/[  ]+/);
        setText(newText.join(" "));
        props.showAlert("Extra spaces has been removed!", "success");
    }
    const handleHyphenSpaces = () => {
        let newText = text.split(/[  ]+/);
        setText(newText.join("-"));
        props.showAlert("Extra spaces removed and hyphen added!", "success");
    }
    const handleHyphenLowerCase = () => {
        let newText = text.split(/[  ]+/);
        setText(newText.join("-").toLowerCase());
        props.showAlert("Extra spaces removed, converted to lower case, and added hyphen!", "success");
    }
    const handleHyphenUpperCase = () => {
        let newText = text.split(/[  ]+/);
        setText(newText.join("-").toUpperCase());
        props.showAlert("Extra spaces removed, converted to UPPER CASE, and added hyphen!", "success");
    }

    const handleClearText = () => {
        let newText = "";
        setText(newText);
        props.showAlert("Text has been cleared!", "success");
    }


    return (
        <>
            <div className='container my-3 text-center'>
                <label htmlFor="textInput"><h3>{props.textFormHeading}</h3></label>
                <div className="mb-3">
                    <textarea className="form-control" name="textInputBox" id="textInput" rows="10" value={text} placeholder="Enter your text here..." onChange={handleOnChange}></textarea>
                </div>
                <button disabled={text.length===0} className="btn btn-primary mx-1 my-1 " onClick={handleUcClick}>UPPER CASE</button>
                <button disabled={text.length===0} className="btn btn-primary mx-1 my-1 " onClick={handleLcClick}>lower case</button>
                <button disabled={text.length===0} className="btn btn-primary mx-1 my-1 " onClick={handleCapsClick}>Capitalized Case</button>
                <button disabled={text.length===0} className="btn btn-primary mx-1 my-1 " onClick={handleExtraSpaces}>Remove Extra Spaces</button>
                <button disabled={text.length===0} className="btn btn-primary mx-1 my-1 " onClick={handleHyphenSpaces}>Add Hyphen</button>
                <button disabled={text.length===0} className="btn btn-primary mx-1 my-1 " onClick={handleHyphenUpperCase}>UPPER CASE and HYPHEN</button>
                <button disabled={text.length===0} className="btn btn-primary mx-1 my-1 " onClick={handleHyphenLowerCase}>lower case and hyphen</button>
                <button disabled={text.length===0} className="btn btn-primary mx-1 my-1 " onClick={handleCopy}>Copy</button>
                <button disabled={text.length===0} className="btn btn-primary mx-1 my-1 " onClick={handleClearText}>Clear</button>
                <button disabled={text.length===0} className="btn btn-primary mx-1 my-1 " onClick={handleSpeakClick}>Speak</button>
            </div>
            <div className="container my-3">
                <h2>Your Text Summary</h2>
                <p>{text.split(" ").filter((element)=>{return element.length!==0}).length} words and {text.length} characters</p>
                <p>{0.008 * text.split(" ").filter((element)=>{return element.length!==0}).length} Minutes read</p>
                <h2>Preview</h2>
                <p>{text.length>0?text:"Nothing to preview!"}</p>
                <h5>Or</h5>
                <pre>{text.length>0?text:"Nothing to preview!"}</pre>
            </div>
        </>
    )
}
